const environment = {
    REACT_APP_E_SWITCH_HOST_URL: window.env && window.env.REACT_APP_E_SWITCH_HOST_URL ? window.env.REACT_APP_E_SWITCH_HOST_URL : process.env.REACT_APP_E_SWITCH_HOST_URL,
    REACT_APP_E_SWITCH_HOST_URL_EXT: window.env && window.env.REACT_APP_E_SWITCH_HOST_URL_EXT ? window.env.REACT_APP_E_SWITCH_HOST_URL_EXT : process.env.REACT_APP_E_SWITCH_HOST_URL_EXT,
    AEM_URL: window.env && window.env.AEM_URL ? window.env.AEM_URL : process.env.AEM_URL,
    FORDPRO_URL: window.location && window.location.origin ? window.location.origin : process.env.FORDPRO_URL,
    FPG_REDIRECT_URL_PATH: window.env && window.env.FPG_REDIRECT_URL_PATH ? window.env.FPG_REDIRECT_URL_PATH : process.env.FPG_REDIRECT_URL_PATH,
};

export default environment;
